/* Mariesse ortak davranışlar: kaydırak, slider, geri sayım, video modalı */
(function () {
  'use strict';

  /* ---------- Yatay kaydırak (carousel) ---------- */
  function kaydirakKur(kutu) {
    if (kutu.dataset.mKurulu === '1') return; // AJAX ile yeniden gelen bölümlerde çift kurulumu engelle
    var serit = kutu.querySelector('[data-m-serit]');
    if (!serit) return;
    kutu.dataset.mKurulu = '1';
    var geri = kutu.querySelector('[data-m-geri]');
    var ileri = kutu.querySelector('[data-m-ileri]');
    var noktalar = Array.prototype.slice.call(kutu.querySelectorAll('[data-m-nokta]'));

    function adim() {
      var kart = serit.firstElementChild;
      if (!kart) return serit.clientWidth;
      var bosluk = parseFloat(getComputedStyle(serit).columnGap) || 24;
      return kart.getBoundingClientRect().width + bosluk;
    }

    if (geri) geri.addEventListener('click', function () { serit.scrollBy({ left: -adim(), behavior: 'smooth' }); });
    if (ileri) ileri.addEventListener('click', function () { serit.scrollBy({ left: adim(), behavior: 'smooth' }); });

    // Taşma yoksa okları ve noktaları gizle
    var noktaKutu = kutu.querySelector('.m-noktalar');
    function tasmaGuncelle() {
      var tasma = serit.scrollWidth > serit.clientWidth + 5;
      if (geri) geri.style.display = tasma ? '' : 'none';
      if (ileri) ileri.style.display = tasma ? '' : 'none';
      if (noktaKutu) noktaKutu.style.display = tasma ? '' : 'none';
    }
    tasmaGuncelle();
    window.addEventListener('resize', tasmaGuncelle);

    if (noktalar.length > 1) {
      var guncelle = function () {
        var azami = Math.max(1, serit.scrollWidth - serit.clientWidth);
        var sira = Math.round((serit.scrollLeft / azami) * (noktalar.length - 1));
        noktalar.forEach(function (n, i) { n.classList.toggle('aktif', i === sira); });
      };
      serit.addEventListener('scroll', guncelle, { passive: true });
      guncelle();
      noktalar.forEach(function (n, i) {
        n.addEventListener('click', function () {
          var azami = serit.scrollWidth - serit.clientWidth;
          serit.scrollTo({ left: azami * (i / (noktalar.length - 1)), behavior: 'smooth' });
        });
      });
    }
  }
  document.querySelectorAll('[data-m-kaydirak]').forEach(kaydirakKur);

  // İlgili ürünler AJAX ile sonradan geliyor; geldiğinde kaydırağı kur.
  document.querySelectorAll('product-recommendations').forEach(function (el) {
    new MutationObserver(function () {
      el.querySelectorAll('[data-m-kaydirak]').forEach(kaydirakKur);
    }).observe(el, { childList: true, subtree: true });
  });

  /* ---------- Slider otomatik oynatma ---------- */
  document.querySelectorAll('[data-m-slider]').forEach(function (kutu) {
    var serit = kutu.querySelector('[data-m-serit]');
    if (!serit || serit.children.length < 2) return;
    if (kutu.dataset.mOtomatik !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sure = (parseInt(kutu.dataset.mSure, 10) || 6) * 1000;
    var duraklat = false;
    kutu.addEventListener('mouseenter', function () { duraklat = true; });
    kutu.addEventListener('mouseleave', function () { duraklat = false; });
    kutu.addEventListener('touchstart', function () { duraklat = true; }, { passive: true });
    kutu.addEventListener('touchend', function () { duraklat = false; }, { passive: true });
    setInterval(function () {
      if (duraklat || document.hidden) return;
      var azami = serit.scrollWidth - serit.clientWidth;
      if (serit.scrollLeft >= azami - 10) {
        serit.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        serit.scrollBy({ left: serit.clientWidth, behavior: 'smooth' });
      }
    }, sure);
  });

  /* ---------- Geri sayım (gün sonuna) ---------- */
  document.querySelectorAll('[data-m-sayac]').forEach(function (el) {
    var birimler = el.querySelectorAll('[data-m-birim]');
    if (birimler.length < 3) return;
    function guncelle() {
      var simdi = new Date();
      var bitis = new Date(simdi.getFullYear(), simdi.getMonth(), simdi.getDate(), 23, 59, 59);
      var kalan = Math.max(0, bitis - simdi);
      var sa = Math.floor(kalan / 3600000);
      var dk = Math.floor((kalan % 3600000) / 60000);
      var sn = Math.floor((kalan % 60000) / 1000);
      birimler[0].textContent = String(sa).padStart(2, '0');
      birimler[1].textContent = String(dk).padStart(2, '0');
      birimler[2].textContent = String(sn).padStart(2, '0');
    }
    guncelle();
    setInterval(guncelle, 1000);
  });

  /* ---------- Mega menü grup değiştirme ---------- */
  document.querySelectorAll('.m-mega').forEach(function (mega) {
    var gruplar = mega.querySelectorAll('[data-m-grup]');
    var panolar = mega.querySelectorAll('[data-m-pano]');
    if (!gruplar.length) return;
    function sec(idx) {
      gruplar.forEach(function (g) { g.classList.toggle('aktif', g.dataset.mGrup === idx); });
      panolar.forEach(function (p) { p.classList.toggle('aktif', p.dataset.mPano === idx); });
    }
    gruplar.forEach(function (g) {
      g.addEventListener('mouseenter', function () { sec(g.dataset.mGrup); });
      g.addEventListener('focus', function () { sec(g.dataset.mGrup); });
      g.addEventListener('click', function () { sec(g.dataset.mGrup); });
    });
  });

  /* ---------- Mobil çekmece ---------- */
  var cekmece = document.getElementById('MariesseCekmece');
  if (cekmece) {
    var acButonlar = document.querySelectorAll('[data-m-cekmece-ac]');
    function cekmeceKapat() {
      cekmece.hidden = true;
      document.body.classList.remove('m-cekmece-acik');
      acButonlar.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    acButonlar.forEach(function (btn) {
      btn.addEventListener('click', function () {
        cekmece.hidden = false;
        document.body.classList.add('m-cekmece-acik');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
    cekmece.querySelectorAll('[data-m-cekmece-kapat]').forEach(function (el) {
      el.addEventListener('click', cekmeceKapat);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cekmece.hidden) cekmeceKapat();
    });
  }

  /* ---------- Video modalı ---------- */
  var videoKutu = null;
  function videoKutuGetir() {
    if (videoKutu) return videoKutu;
    videoKutu = document.createElement('dialog');
    videoKutu.className = 'm-video-kutu';
    videoKutu.innerHTML = '<div class="m-video-kutu__ic"><button type="button" class="m-video-kutu__kapat" aria-label="Kapat">&times;</button><div data-m-video-yeri></div></div>';
    document.body.appendChild(videoKutu);
    function kapat() {
      videoKutu.querySelector('[data-m-video-yeri]').innerHTML = '';
      if (videoKutu.open) videoKutu.close();
    }
    videoKutu.querySelector('.m-video-kutu__kapat').addEventListener('click', kapat);
    videoKutu.addEventListener('click', function (e) { if (e.target === videoKutu) kapat(); });
    videoKutu.addEventListener('close', function () { videoKutu.querySelector('[data-m-video-yeri]').innerHTML = ''; });
    return videoKutu;
  }

  document.addEventListener('click', function (e) {
    var dugme = e.target.closest('[data-m-video-tur]');
    if (!dugme) return;
    var tur = dugme.dataset.mVideoTur;
    var kaynak = dugme.dataset.mVideoKaynak;
    if (!tur || !kaynak) return;
    e.preventDefault();
    var kutu = videoKutuGetir();
    var yer = kutu.querySelector('[data-m-video-yeri]');
    if (tur === 'youtube') {
      yer.innerHTML = '<iframe src="https://www.youtube.com/embed/' + kaynak + '?autoplay=1&playsinline=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (tur === 'vimeo') {
      yer.innerHTML = '<iframe src="https://player.vimeo.com/video/' + kaynak + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else {
      var video = document.createElement('video');
      video.src = kaynak;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      yer.innerHTML = '';
      yer.appendChild(video);
    }
    kutu.showModal();
  });
})();

/* ---------- Ölçü rehberi sekmeleri ---------- */
document.querySelectorAll('.m-rehber').forEach(function (rehber) {
  var sekmeler = rehber.querySelectorAll('[data-m-sekme]');
  var panolar = rehber.querySelectorAll('[data-m-sekme-pano]');
  if (!sekmeler.length) return;
  sekmeler.forEach(function (s) {
    s.addEventListener('click', function () {
      sekmeler.forEach(function (x) {
        var aktif = x === s;
        x.classList.toggle('aktif', aktif);
        x.setAttribute('aria-selected', aktif ? 'true' : 'false');
      });
      panolar.forEach(function (p) {
        p.classList.toggle('aktif', p.dataset.mSekmePano === s.dataset.mSekme);
      });
    });
  });
});

/* ---------- Yorumlar: "Tüm Yorumları Gör" genişletme ---------- */
document.querySelectorAll('[data-m-yorum-bolum]').forEach(function (bolum) {
  var dugme = bolum.querySelector('[data-m-yorum-daha]');
  if (!dugme) return;
  dugme.addEventListener('click', function () {
    var acik = bolum.classList.toggle('m-yorum--acik');
    dugme.setAttribute('aria-expanded', acik ? 'true' : 'false');
    dugme.textContent = acik ? dugme.dataset.mKapaMetin : dugme.dataset.mAcMetin;
    if (!acik) bolum.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
